var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-view"},[_c('div',{staticClass:"user-view__top"}),_c('div',{staticClass:"user-view__content"},[_c('div',{staticClass:"container-custom"},[_c('assistant-details',{attrs:{"userId":_vm.$route.params.id}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }